import React, { useState, useMemo } from "react";
import { useRateCard } from "../../../hooks/useRateCards";
import Table from "../../../components/table/table";
import { Button } from "../../../components/button/button";
import { rateCardsCollection } from "../../../services/firebase";
import { EncircledPlusIcon } from "../../../utils/svg-components";
import { getFirstWord } from "../../../utils/utils";
import RateColumns from "./rate-columns";
import CreateRateCard from "./create-rate/create-rate-card";
import { RateTableStyled } from "./rate-card-table.styles";

const RateCardTable = () => {
  const { data: rateCards = [], refetch } = useRateCard();

  const [showModal, setShowModal] = useState(false);
  const [editing, setEditing] = useState(null);

  // --- 1. pull out the default, then concat the rest
  const defaultCard = rateCards.find((rc) => rc.isDefault);
  const otherCards = rateCards
    .filter((rc) => !rc.isDefault)
    .sort((a, b) => getFirstWord(a.name).localeCompare(getFirstWord(b.name)));

  const ordered = defaultCard
    ? [
        { ...defaultCard },
        ...otherCards.sort((a, b) => a.name.localeCompare(b.name)),
      ]
    : [...rateCards].sort((a, b) => a.name.localeCompare(b.name));

  const openNew = () => {
    setEditing(null);
    setShowModal(true);
  };
  const openEdit = (rc) => {
    setEditing(rc);
    setShowModal(true);
  };
  const close = () => {
    setEditing(null);
    setShowModal(false);
    refetch();
  };

  const handleDelete = async (id, name) => {
    const ok = window.confirm(`Delete rate card "${name}"?`);
    if (!ok) return;

    try {
      await rateCardsCollection.doc(id).delete();
      // If useRateCard is realtime, table will refresh automatically.
      // Otherwise you could re-fetch or mutate your cache here.
    } catch (err) {
      console.error("Failed to delete rate card", err);
      alert("Sorry, could not delete—see console for details.");
    }
    refetch();
  };

  return (
    <RateTableStyled>
      <div className="buttonContainer">
        <Button
          variant="filled"
          color={"tertiary"}
          startIcon={<EncircledPlusIcon />}
          onClick={openNew}
        >
          Add Rate Card
        </Button>
      </div>

      <Table
        data={ordered}
        columns={RateColumns(handleDelete, openEdit)}
        noDataMessage="No rate cards available"
        stickyHeader
      />

      {showModal && (
        <CreateRateCard
          initialData={editing}
          onClose={close}
          onSuccess={close}
        />
      )}
    </RateTableStyled>
  );
};

export default RateCardTable;
